import moment from "moment";
import Chart from "react-apexcharts";

export default function ThirtyDaysSaleHistoryChart({ productSaleHistory }) {
  console.log(
    "🚀 ~ ThirtyDaysSaleHistoryChart ~ productSaleHistory:",
    productSaleHistory
  );

  const dates = productSaleHistory[0].thirty_days_sales.reduce((acc, item) => {
    acc.push(moment(item.sale_date).format("DD MMM"));
    return acc;
  }, []);
  const total_sales = productSaleHistory[0].thirty_days_sales.reduce(
    (acc, item) => {
      acc.push(item.total_quantity);
      return acc;
    },
    []
  );

  let chart = {
    options: {
      chart: {
        background: "#fff",
      },
      xaxis: {
        categories: dates,
      },
      stroke: { curve: "smooth" },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 250,
              height: 250,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
    series: [
      {
        name: "sales",
        data: total_sales,
      },
    ],
  };

  return (
    <section className="details">
      <div className="price_history">
        <Chart
          options={chart.options}
          series={chart.series}
          type="bar"
          width="1000"
        />
      </div>
    </section>
  );
}
